import { render, staticRenderFns } from "./IconBaseLine.vue?vue&type=template&id=539c1696"
import script from "./IconBaseLine.vue?vue&type=script&lang=js"
export * from "./IconBaseLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports